import { Box, Button, Card, CardActionArea, CardContent, CardMedia, Container, Grid, Stack, TextField, Typography } from "@mui/material"
import Bottom from "./Bottom";
import useEncyclopediaStore from "../store/encyclopediaStore";
import { useEffect } from "react";
import api from "../utils/api_v2";
import LodingData from "../utils/LodingData";
import Pagination from "react-js-pagination";
import SearchIcon from '@mui/icons-material/Search';

import "../components/common/PaginationComponent.css";
import tabbg from "../assets/images/tab_03.png"
import { useNavigate } from "react-router-dom";



const Encyclopedia = () => {

  const storeData: any = useEncyclopediaStore();
  const navigate = useNavigate();

  useEffect(() => {
    getEncyclopediaList();

    return () => {
      storeData.clear();
    }
  }, [])


  const handleSearchButton = () => {
    if (storeData.encyclopediaListParams.searchWord.length == 1) {
      alert('두 글자 이상 검색어로 입력주세요.');
      return false;
    }
    getEncyclopediaList();
  }

  // input 엔터 시
  const handleActiveEnter = (e: any) => {
    if (e.key == 'Enter') {
      handleSearchButton();
    }
  }

  function getEncyclopediaList() {
    LodingData(() => api.post('customer/api/v1/CU0901', storeData.encyclopediaListParams)
      .then(res => {
        console.log(res);
        storeData.setEncyclopediaList(res.data.healthContentDTOList);
        storeData.setEncyclopediaListCount(res.data.count);
      })
      .catch(err => {
        console.log(err);
      }));
  }

  // 검색 input 핸들러
  const handleSerachInputChange = (e: any) => {
    storeData.setEncyclopediaListParams(e.target.name, e.target.value);
  }

  function handlePageChange(page: number) {
    storeData.setEncyclopediaListParams('pageNum', page - 1);
    getEncyclopediaList();
  }



  return (
    <Container className="container">
      <Box sx={img} >
        <Grid container spacing={2} direction='row' justifyContent='center' alignItems={'center'} sx={{ overflow: 'hidden', height: 200, textAlign: 'center' }}>
          <Grid item container xs sx={{ pl: 0 }} direction='column' justifyContent='center'>
            <Typography className='topText' sx={{ fontSize: '2.2rem', color: '#b2f7ab', fontWeight: 900, }}>
              건강정보
            </Typography>
            <Typography sx={{ fontSize: '1.8rem', color: '#5ee725', fontWeight: 500, }} gutterBottom>
              질병백과
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box className="wb_search" sx={{ width: 410, ml: 24 }}>
        <TextField id="outlined-basic" className='wb_searchinput' variant="outlined" name="searchWord" value={storeData.encyclopediaListParams.searchWord} onChange={handleSerachInputChange} onKeyDown={handleActiveEnter} placeholder='제목으로 검색하세요.' size='small' />
        <Button className='search_icon' variant="contained" onClick={handleSearchButton} startIcon={<SearchIcon />}></Button>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateRows: "1fr",
          gridTemplateColumns: "1fr 1fr 1fr 1fr",
          mt: 1
          , width: '80%', mr: 'auto', ml: 'auto'
        }}
      >
        {
          storeData.encyclopediaList && storeData.encyclopediaList.map((item: any, index: any) => {
            return (
              <Card key={index} sx={{ marginTop: 4, marginLeft: 4.5, boxShadow: '0px 0px 0px rgba(0,0,0,0)!important', borderRadius: 4 }}>
                <CardActionArea onClick={() => navigate('encyclopediaDetail', { state: item.id })} sx={{ border: '1px solid #ccc', p: 1 }}>
                  {
                    item.fileName.includes('s3')
                      ? <CardMedia
                        component="img"
                        height="200"
                        image={item.fileName}
                        alt={item.title}
                        sx={{ borderRadius: 3 }}
                      />
                      : <CardMedia
                        component="img"
                        height="200"
                        image={'https://file.dualhealth.kr/healthContent/images/' + item.fileName}
                        alt={item.title}
                        sx={{ borderRadius: 3 }}
                      />
                  }
                  <CardContent sx={{ height: '50px', p: "10px 0px 0px 5px !important" }} className="display_flex flexdirection_column justifycontent_spacebetween">
                    <Typography className="font_weight">{item.title}</Typography>

                    {/* <Stack direction={'row'}>
                      {item.author}
                    </Stack> */}

                  </CardContent>
                </CardActionArea>
              </Card>
            )
          })
        }

      </Box>

      <Grid container className='foot_list'>
        <Pagination
          activePage={storeData.encyclopediaListParams.pageNum + 1} // 현재 페이지
          itemsCountPerPage={12} // 한 페이지에 보여줄 아이템 갯수
          totalItemsCount={storeData.encyclopediaListCount} // 총 아이템 갯수
          pageRangeDisplayed={10} // paginator의 페이지 범위
          prevPageText={"‹"} // "이전"을 나타낼 텍스트
          nextPageText={"›"} // "다음"을 나타낼 텍스트
          onChange={handlePageChange} // 페이지 변경을 핸들링하는 함수
        />
      </Grid>

      <Bottom />
    </Container>
  )
}
const img = {
  display: 'flex', p: 0, backgroundImage: `url(${tabbg})`, backgroundSize: 'cover', mb: 5, borderRadius: 2
}
export default Encyclopedia;